// @flow

import React from "react";
import SearchContext from "../../searchContext";
import SearchableTextInput from "../SearchableTextInput";
import SearchDateFilter from "../SearchDateFilter";

const SearchFiltersContainer = () => {
  return (
    <SearchContext.Consumer>
      {({ setFilters, translations }) => {
        return (
          <div className="filter-wrapper">
            <div className="filter-results-label">
              {translations?.search_results_filters_label ??
                "Filtra i risultati"}
            </div>
            <div className="fields">
              <div className="field-wrapper">
                <SearchableTextInput
                  onUpdateValue={setFilters}
                  translations={translations}
                />
              </div>

              <SearchDateFilter
                onUpdateValue={setFilters}
                translations={translations}
              />
            </div>
          </div>
        );
      }}
    </SearchContext.Consumer>
  );
};

export default SearchFiltersContainer;
